<template>
    <div class="flex flex-col min-h-screen bg-gray-50 md:flex-row">
        <div class="relative flex-grow-0">
            <!-- <img :src="asset('img/onboarding-bg.jpg')" class="absolute inset-0 object-cover object-left-top w-full h-full" /> -->

            <div class="relative z-10 flex justify-center py-5 sm:min-w-[400px]">
                <app-logo></app-logo>
            </div>
        </div>

        <div class="relative flex-1">
            <div class="container flex flex-col items-center justify-center h-full">
                <div class="w-full py-10">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLogo from '@Components/ApplicationLogo'

export default {
    components: {
        AppLogo
    },
    props: {

    }
}
</script>

<style>

</style>
